// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"_1Euml___IndexPage-module__thumbnail"};